export default "__VITE_ASSET__DKNKVZzf__"